export const isNonEmpty = (obj: Object) => {
  return Object.keys(obj).length;
};

export const int2Bool = (value: number) => {
  if (value > 0) {
    return true;
  } else {
    return false;
  }
};

export const timeConverter = (
  unixTimestamp: string,
  withTime?: boolean | undefined
) => {
  const a = new Date(parseInt(unixTimestamp));
  const months = [
    "January",
    "February",
    "March",
    "Aprril",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const date = a.getDate();
  const hour = a.getHours();
  const min = a.getMinutes();
  const sec = a.getSeconds();
  let time = month + " " + date + " " + year + " ";
  if (withTime) {
    time += hour + ":" + min + ":" + sec;
  }
  return time;
};

export function getUTCDateStringFromDate(date: Date) {
	const dateString = `${date.getUTCFullYear()}-${
	date.getUTCMonth() + 1 < 10 ? 0 + date.getUTCMonth() + 1 : date.getUTCMonth() + 1
	}-${date.getUTCDate() < 10 ? 0 + date.getUTCDate().toString() : date.getUTCDate()}`
	return dateString
}
